// modules
import React, { Component } from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from 'react-redux'
// src
// import { devLog } from './constants'
import FixBox from '../components/FixBox'
import AreaTable from '../components/AreaTable'
// import AreaMap from '../components/AreaMap'
import DeliveryDateCalendar from '../components/DeliveryDateCalendar'
import SelectSpeedType from '../components/SelectSpeedType'
import SelectHouseType from '../components/SelectHouseType'
import SelectPaperSizeType from '../components/SelectPaperSizeType'
// import SelectFoldingType from '../components/SelectFoldingType'
import SelectPrintNumType from '../components/SelectPrintNumType'
import SelectPaperQualityType from '../components/SelectPaperQualityType'
import SelectColorType from '../components/SelectColorType'
import SelectGapType from '../components/SelectGapType'
// import SelectRequestDesignType from '../components/SelectRequestDesignType'
import DialogDesignTemplate from '../components/DialogDesignTemplate'
import SelectRequestMapType from '../components/SelectRequestMapType'
// import Popover from '@material-ui/core/Popover';
import Paper from '@material-ui/core/Paper';

import { getInitialOptions } from '../actions/options'

const styles = theme => ({
    hoverSwitch:{
        position:'relative',
        '&:hover >.hoverPop':{
            display:'block',
        }
    },
    hoverPop:{
        backgroundColor:'#ccc',
        padding: theme.spacing.unit,
        boxShadow: '0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)',
    },
    popoverImg:{
        width:300,
        boxShadow: '1px 1px 5px #999',
    },
    popoverText:{
        width:300,
        marginTop:10,
        color:"#333",
    }
})

class SetPackRecruit extends Component {
    componentDidMount() {
        this.props.getInitialOptions()
    }
    render() {
        const { classes } = this.props;
        return (
            <div className="ViewSetPackRecruit">
                <div className="rightCol">
                    <FixBox />
                </div>
                <div className="leftCol">
                    <h2 className="productTitle">求人チラシ印刷＋ポスティング</h2>
                    <AreaTable />
                    <DeliveryDateCalendar />
                    <table className="optionTable">
                        <tbody>
                            <tr>
                                <th><span>配布期間</span></th>
                                <td>
                                    <span>
                                        <SelectSpeedType />
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th><span>住居指定</span></th>
                                <td>
                                    <span>
                                        <SelectHouseType />
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th><span>用紙サイズ</span></th>
                                <td>
                                    <span>
                                        <SelectPaperSizeType />
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th><span>印刷部数</span></th>
                                <td>
                                    <span>
                                        <SelectPrintNumType />
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th><span>印刷用紙・厚さ</span></th>
                                <td>
                                    <span>
                                        <SelectPaperQualityType />
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th><span>印刷色数</span></th>
                                <td>
                                    <span className={classes.hoverSwitch} >
                                        <SelectColorType />
                                        <div className="hoverPop">
                                            <Paper className={classes.hoverPop} elevation={1}>
                                                <img
                                                    className={classes.popoverImg}
                                                    src={process.env.REACT_APP_SITE_URL+"user_data/packages/default/img/recruit/sample4c1c.png"}
                                                    alt="履歴書サンプル"
                                                />
                                                <div className={classes.popoverText}>
                                                    ※「カラー片面/モノクロ片面(4C/1C)」を選択の場合、裏面は上記ような履歴書付きになります。
                                                </div>
                                            </Paper>
                                        </div>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th><span>印刷端数</span></th>
                                <td>
                                    <span>
                                        <SelectGapType />
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th><span>デザイン制作</span></th>
                                <td>
                                    <span>
                                        <DialogDesignTemplate />
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th><span>地図</span></th>
                                <td>
                                    <span>
                                        <SelectRequestMapType />
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    // member: state.members.one,
})

const mapDispatchToProps = dispatch => ({
    getInitialOptions: () => dispatch(getInitialOptions()),
})


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(SetPackRecruit));



// WEBPACK FOOTER //
// ./src/views/SetPackRecruit.js